module.exports = __webpack_public_path__ + "f7ee020c35edc5ac17f38d455fb96320.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/icons/closeIcon.png
// module id = k8Z6
// module chunks = 22